import React from 'react';
import { CheckCircle, Info } from 'lucide-react';
import { VARIANTS } from './constants';

export const StyleSelector = ({ selectedVariant, onVariantChange }) => {
  return (
    <div className="border-t pt-6">
      <h3 className="text-base font-bold mb-4">Select Your Style</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {VARIANTS.map(variant => (
          <button
            key={variant.value}
            type="button"
            onClick={() => onVariantChange(variant.value)}
            className={`relative p-4 rounded-xl border-2 text-left transition-all ${
              selectedVariant === variant.value
                ? 'border-primary bg-primary/5 shadow-md'
                : 'border-gray-200 hover:border-gray-300 bg-white'
            }`}
          >
            {selectedVariant === variant.value && (
              <CheckCircle className="absolute top-2 right-2 w-5 h-5 text-primary" />
            )}
            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${variant.color}`}>
              {variant.label}
            </span>
            <p className="text-xs text-gray-500 mt-2 line-clamp-2">{variant.description}</p>
          </button>
        ))}
      </div>

      {/* Selected Variant Details */}
      {selectedVariant && (
        <div className="mt-4 p-4 bg-primary/5 rounded-lg border border-primary/20">
          <div className="flex items-start gap-3">
            <Info className="w-5 h-5 text-primary mt-0.5" />
            <div>
              <h4 className="font-semibold text-primary">
                {VARIANTS.find(v => v.value === selectedVariant)?.label} Style
              </h4>
              <p className="text-sm text-gray-600 mt-1">
                {VARIANTS.find(v => v.value === selectedVariant)?.description}
              </p>
              <p className="text-xs text-gray-500 mt-1">
                {VARIANTS.find(v => v.value === selectedVariant)?.materials}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StyleSelector;
